import React from "react";
import {
    HelpDirectoryRepository,
    HelpFileRepository
} from "../../../repository";
import {HelpFile} from "../../../model";
import {EntityFormTemplate} from "../../../component/template/EntityFormTemplate";
import * as Yup from "yup";

export const UpdateHelpFile = () => {

    const typeOptions = [
        { value: "file", label: "Fichier" },
        { value: "video", label: "Vidéo" },
    ]

    // @ts-ignore
    return (
        <EntityFormTemplate<HelpFile>
            mode={'update'}
            repository={new HelpFileRepository()}
            title={{
                page: `Document (Aide en ligne)`,
                schema: `Modifier le document "$0"`,
                params: [`name`]
            }}
            fields= {[
                {label: `Nom`, id: 'name', type: 'text'},
                {label: `Description`, id: 'description', type: 'text'},
                {label: `Permission`, id: 'permission', type: 'text'},
                {label: `Type`, id: 'type', type: 'select', options: typeOptions},
                {label: `Version`, id: 'version', type: 'text'},
                {label: `Répertoire`, id: 'directory', type: 'relation', repository: new HelpDirectoryRepository()},
                {label: `Fichier`, id: 'helpFile', type: 'file', hint:`(taille < 5Mo)`, hidden: (values: any) => values?.type !== 'file' },
                {label: `URL de la vidéo`, id: 'helpUrl', type: 'text', hidden: (values: any) => values?.type !== 'video'},
                {label: `Miniature`, id: 'thumbnailFile', type: 'file', hint:`(taille < 5Mo)` },
            ]}
            validationSchema={
                Yup.object().shape({
                    name: Yup.string()
                        .min(3, 'Minimum 3 caractères.')
                        .max(200, 'Maximum 200 caractères.')
                        .required('Obligatoire'),
                    permission: Yup.string()
                        .permission("Doit être composé de lettres minuscules et de tirets."),
                    type: Yup.string()
                        .required("Obligatoire"),
                    version: Yup.string()
                        .version("Format x.y attendu.")
                        .required('Obligatoire'),
                    directory: Yup.mixed()
                        .relation("HelpDirectory", "Répertoire invalide.")
                        .required('Obligatoire'),
                    helpFile: Yup.mixed()
                        .fileType("document", "Type de fichier non supporté.")
                        .fileSize(5000, "Fichier trop volumineux."),
                    helpUrl: Yup.string()
                        .max(250, 'Maximum 250 caractères.'),
                    thumbnailFile: Yup.mixed()
                        .fileType("image", "Type de fichier non supporté.")
                        .fileSize(5000, "Fichier trop volumineux."),
                })
            }
        />
    )
}